import { useFormContext } from 'react-hook-form';
import { CardTitle } from '@/components/ui/Card.tsx';
import SingleSelectInput from '@/components/form/SingleSelectInput.tsx';
import { ClientInputFormWithCustomFields } from '@/features/public/booking/schemas/clientSchema.ts';
import { BookingInsurancesDto } from '@/features/public/booking/types/BookingInsurancesDto.ts';

interface ParticipantInsuranceSelectProps {
  index: number;
  bookingInsurances?: BookingInsurancesDto | null;
}

const ParticipantInsuranceSelect = ({
  index,
  bookingInsurances,
}: ParticipantInsuranceSelectProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<ClientInputFormWithCustomFields>();

  if (!bookingInsurances || bookingInsurances.insurances.length === 0) {
    return null;
  }

  const options = bookingInsurances.insurances.map((insurance) => ({
    label: insurance.name,
    value: insurance.id,
  }));

  return (
    <>
      <CardTitle className="pt-2">Ubezpieczenie</CardTitle>
      <SingleSelectInput
        label="Wybierz ubezpieczenie"
        fieldName={`participants.${index}.selectedInsuranceId`}
        control={control}
        placeholder="Wybierz ubezpieczenie..."
        options={options}
        required={bookingInsurances.required}
        isClearable={!bookingInsurances.required}
        error={errors.participants?.[index]?.selectedInsuranceId?.message}
      />
    </>
  );
};

export default ParticipantInsuranceSelect;
